import React, { useEffect, useState } from "react";
import { Layout, Menu, MenuProps } from "antd";
import {
  SettingOutlined,
  DesktopOutlined,
  InboxOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  ContainerOutlined,
  ProfileOutlined,
  SolutionOutlined,
  PieChartOutlined,
} from "@ant-design/icons";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import CategoryIcon from "@mui/icons-material/Category";
import SummarizeIcon from "@mui/icons-material/Summarize";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import CropRotateIcon from "@mui/icons-material/CropRotate";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import BuildIcon from "@mui/icons-material/Build";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import AddCommentIcon from "@mui/icons-material/AddComment";
import GroupsIcon from "@mui/icons-material/Groups";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import DatasetOutlinedIcon from "@mui/icons-material/DatasetOutlined";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import StorageIcon from "@mui/icons-material/Storage";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import FolderSharedOutlinedIcon from "@mui/icons-material/FolderSharedOutlined";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';

import "./sidebar.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const { Sider } = Layout;
type propsType = {
  open: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
};
export const Sidebar = (props: propsType) => {
  useEffect(() => {
    if (!props.open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [props.open]);

  const { t } = useTranslation("common");
  type MenuItem = Required<MenuProps>["items"][number];

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }
  // const { pathname } = useLocation();
  // const path = pathname.replace(/\//g, "");

  const items: MenuItem[] = [
    // getItem(
    //   `${t("dashboard")}`,
    //   "sub1",
    //   <PieChartOutlined style={{ fontSize: "20px" }} />,
    //   [
    //     getItem(
    //       `${t("general")}`,
    //       "1",
    //       <DashboardCustomizeIcon style={{ fontSize: "20px" }} />
    //     ),
    //     getItem(
    //       <Link to="/dashboard/inventory">{t("inventory")}</Link>,
    //       "2",
    //       <Inventory2OutlinedIcon style={{ fontSize: "20px" }} />
    //     ),
    //     getItem(
    //       <Link to="/dashboard/Purchase">{t("purchases")}</Link>,
    //       "3",
    //       <StorageIcon style={{ fontSize: "20px" }} />
    //     ),
    //     getItem(
    //       `${t("sales")}`,
    //       "33",
    //       <ShoppingBagOutlinedIcon style={{ fontSize: "20px" }} />
    //     ),
    //   ]
    // ),
    getItem(
      `${t("pos")}`,
      "sub2",
      <PointOfSaleIcon style={{ fontSize: "20px" }} />,
      [
        getItem(
          <Link to="/information">{t("till-summary")}</Link>,
          "4",
          <InboxOutlined style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/main">{t("main")}</Link>,
          "5",
          <DesktopOutlined style={{ fontSize: "20px" }} />
        ),
      ]
    ),
    getItem(
      `${t("purchases")}`,
      "sub4",
      <PriceCheckIcon style={{ fontSize: "20px" }} />,
      [
        getItem(
          <Link to="/suppliers">{t("suppliers")}</Link>,
          "12",
          <DeliveryDiningIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/bills">{t("bills")}</Link>,
          "13",
          <PriceChangeIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/supplierpayment">{t("payments")}</Link>,
          "14",
          <CreditScoreIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/supplierbalance">{t("transactions")}</Link>,
          "16",
          <AccountBalanceWalletIcon style={{ fontSize: "20px" }} />
        ),
        // getItem(
        //   <Link to="/return">{t("returns")}</Link>,
        //   "15",
        //   <KeyboardReturnIcon style={{ fontSize: "20px" }} />
        // ),
      ]
    ),
    getItem(
      `${t("sales")}`,
      "sub3",
      <ShoppingCartOutlined style={{ fontSize: "20px" }} />,
      [
        getItem(
          <Link to="/priceList">{t("menu-price-lists")}</Link>,
          "32",
          <ProfileOutlined style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/customers">{t("menu-customers")}</Link>,
          "6",
          <SolutionOutlined style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/invoices">{t("invoices")}</Link>,
          "8",
          <ContainerOutlined style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/customerreceipts">{t("receipts")}</Link>,
          "9",
          <CreditScoreIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/customerbalance">{t("transactions")}</Link>,
          "11",
          <AccountBalanceWalletIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/sales">{t("returns")}</Link>,
          "10",
          <KeyboardReturnIcon style={{ fontSize: "20px" }} />
        ),
      ]
    ),
    getItem(
      `${t("inventorie")}`,
      "sub5",
      <InventoryOutlinedIcon style={{ fontSize: "20px" }} />,
      [
        getItem(
          <Link to="/warehouses">{t("warehouses")}</Link>,
          "17",
          <WarehouseIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/inventory/beginning">{t("beginning")}</Link>,
          "20",
          <WarehouseOutlinedIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="cactegory">{t("categories")}</Link>,
          "18",
          <DatasetOutlinedIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/items">{t("items")}</Link>,
          "19",
          <CategoryIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/inventory/summary">{t("summary")}</Link>,
          "21",
          <SummarizeIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          `${t("transfers")}`,
          "22",
          <MoveDownIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          `${t("adjustments")}`,
          "23",
          <CropRotateIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/inventory/count">{t("count")}</Link>,
          "24",
          <CalculateOutlinedIcon style={{ fontSize: "20px" }} />
        ),
      ]
    ),
    getItem(
      `${t("system")}`,
      "sub6",
      <SystemUpdateAltIcon style={{ fontSize: "20px" }} />,
      [
        getItem(
          <Link to="/roles">{t("roles")}</Link>,
          "25",
          <GroupsIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/users">{t("users")}</Link>,
          "26",
          <UserOutlined style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/Permissions">{t("permissions")}</Link>,
          "27",
          <FolderSharedOutlinedIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/references">{t("references")}</Link>,
          "28",
          <ManageAccountsIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/exchange-rate">{t("exchange-rates")}</Link>,
          "29",
          <CurrencyExchangeIcon style={{ fontSize: "20px" }} />
        ),
        getItem(
          <Link to="/settings">{t("settings")}</Link>,
          "24",
          <SettingOutlined style={{ fontSize: "20px" }} />
        ),
      ]
    ),
    // getItem(
    //   `${t("tools")}`,
    //   "sub7",
    //   <BuildIcon style={{ fontSize: "20px" }} />,
    //   [
    //     getItem(
    //       `${t("chats")}`,
    //       "30",
    //       <AddCommentIcon style={{ fontSize: "20px" }} />
    //     ),
    //     getItem(
    //       `${t("alerts")}`,
    //       "31",
    //       <AssignmentLateIcon style={{ fontSize: "20px" }} />
    //     ),
    //     getItem(
    //       `${t("support")}`,
    //       "34",
    //       <ContactSupportIcon style={{ fontSize: "20px" }} />
    //     ),
    //   ]
    // ),
  ];
  /*Code for menu */
  const rootSubmenuKeys = [
    "sub1",
    "sub2",
    "sub3",
    "sub4",
    "sub5",
    "sub6",
    "sub7",
  ];
  const [selectedKey] = useState("5");
  const [selectedSubMenuKey, setSelectedSubMenuKey] = useState(
    localStorage.getItem("selectedKey") || ""
  );
  const [openKeys, setOpenKeys] = useState(["sub2"]);
  const onOpenChange: MenuProps["onOpenChange"] = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    const rootKeys = rootSubmenuKeys.filter((key) => keys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) !== -1) {
      setOpenKeys([latestOpenKey]);
    } else {
      setOpenKeys(keys.filter((key) => rootKeys.indexOf(key) === -1));
    }
  };
  // const [selectedSubMenuKey, setSelectedSubMenuKey] = useState("");
  const handleSubMenuSelect = (key: React.Key) => {
    setSelectedSubMenuKey(key.toString());
  };
  if (props.open) {
    return null; // Don't render the Sidebar component when open is true
  }
  return (
    <Layout
      style={
        props.open
          ? { display: "none" }
          : {
            width: "272px",
            height: "100vh",
            position: "fixed",
            zIndex: 99999,
            opacity: "0.95",
            background: "#0047FF",
          }
      }
    >
      <Sider trigger={null} collapsible collapsed={props.open}>
        <Menu
          style={{
            paddingTop: "30px",
            background: "#0047FF",
          }}
          className="menustyle"
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          mode="inline"
          defaultSelectedKeys={[selectedKey]}
          items={items}
          onSelect={({ key }) => handleSubMenuSelect(key)}
          // Pass the selected sub-menu key to the Menu component
          selectedKeys={[selectedSubMenuKey]}
        />
      </Sider>
    </Layout>
  );
};
